import React, { useContext, useEffect, useState } from 'react';
import ReceiptDocument from './PaymentReceiptDocument/PaymentReceiptDocument';
import { PassengerAPI } from '../../../../../../../API/PassengerAPIs/PassengerAPIs';
import { useNavigate } from 'react-router-dom';
import NotificationContext from '../../../../../../../STCLibrary/NotificationSystem/NotificationContext';
import ApiResponseHandler from '../../../../../../../STCLibrary/ApiResponseHandler/ApiResponseHandler';


export default function PaymentReceipt({payment}) {

  const navigate = useNavigate();
  const notificationCtx = useContext(NotificationContext);

  const [loadingTour, setLoadingTour] = useState(true);
  const [loadingPassenger, setLoadingPassenger] = useState(true);
  const [loadingPayer, setLoadingPayer] = useState(true);
  const [passenger, setPassenger] = useState();
  const [tour, setTour] = useState();
  const [payer, setPayer] = useState();

  const getPassengerDetails = () => {
    PassengerAPI.GetPortalPassengers(payment.payerId)
    .then((response) => {
      if(response.status === 200){
          response.data.map((passenger) => {
            if(passenger.id === payment.portalPassengerId){
              setPassenger(passenger);
            }
          })
          setLoadingPassenger(false);
      }
  })
  .catch((err) => {
      console.log(err);
      ApiResponseHandler(err.response, notificationCtx, navigate);
  })
  }

  const getTourInfo = () => {
    PassengerAPI.GetTourDetails(payment.bookingId)
    .then((response) => {
        if(response.status === 200){
            setTour(response.data);
            setLoadingTour(false);
        }
    })
    .catch((err) => {
        console.log(err);
        ApiResponseHandler(err.response, notificationCtx, navigate);
    })
}

const getPayerInfo = () => {
  PassengerAPI.GetPortalAccount(payment.payerId)
  .then((response) => {
    if(response.status === 200){
        setPayer(response.data);
        setLoadingPayer(false);
    }
})
.catch((err) => {
    console.log(err);
    ApiResponseHandler(err.response, notificationCtx, navigate);
})
}

  useEffect(() => {
    getPassengerDetails();
    getTourInfo();
    getPayerInfo();
  }, [])

  return (
    <div>
      {(!loadingTour && !loadingPassenger && !loadingPayer) ? <ReceiptDocument payer={payer} tour={tour} passenger={passenger} payment={payment} /> : 'Loading...'}
    </div>
  );
}
